import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
// import getSitesForStaticPaths from 'helpers/getSitesForStaticPaths'
import ARTICLE_QUERY from 'graphql/article.query'

import Loading from 'components/Loading'
import Layout from 'components/Layout'
import WordpressSEO from 'components/WordpressSEO'
import ArticleTemplate from 'components/ArticleTemplate'
import StateInitializer from '../../../components/StateInitializer'
import getGlobalSettings from '../../../helpers/getGlobalSettings'
import getSites from '../../../helpers/getSites'
import { createApolloClient } from '../../../lib/createApolloClient'
import * as Sentry from '@sentry/nextjs'

function Article({
  globalSettings,
  sites,
  siteSlug,
  post = null,
  site = '',
  slug = '',
}) {
  const router = useRouter()
  if (router.fallback || !post) return <Loading />

  // todo: if no 'post' set by this point we should show the 404 instead of Loading

  return (
    <StateInitializer
      globalSettings={globalSettings}
      sites={sites}
      siteSlug={siteSlug}
    >
      <Layout globalSettings={globalSettings}>
        <WordpressSEO
          url={`/${site}/article/${slug}`}
          seo={post.seo}
          title={post.title}
        />
        <ArticleTemplate data={{ postBy: post }} />
      </Layout>
    </StateInitializer>
  )
}

Article.propTypes = {
  globalSettings: PropTypes.object.isRequired,
  sites: PropTypes.array.isRequired,
  siteSlug: PropTypes.string.isRequired,
  site: PropTypes.string, // TODO possibly remove this
  slug: PropTypes.string,
  post: PropTypes.object,
}

export default Article

export async function getStaticProps({ params }) {
  const { site, slug } = params

  const apolloClient = createApolloClient()

  Sentry.addBreadcrumb({
    message: `getStaticProps for Article page called - site: ${site}, slug: ${slug}`,
    data: { params },
    level: 'info',
    category: 'getStaticProps',
  })

  const [globalSettings, sites, { data, error }] = await Promise.all([
    getGlobalSettings(site),
    getSites(),
    apolloClient.query({
      query: ARTICLE_QUERY,
      context: { site },
      variables: { slug },
    }),
  ])

  if (error) {
    Sentry.captureException(new Error(`Error loading Article props - ${error}`))
    console.error(`Error loading Article props - ${error}`)
  }

  return {
    props: {
      ...params,
      post: data.postBy,
      globalSettings,
      sites,
      siteSlug: site,
    },
    revalidate: 60 * 60, // Revalidate every hour
  }
}

export async function getStaticPaths() {
  const paths = []

  // const sites = await getSitesForStaticPaths(
  //   ({ site, offset }) => ({
  //     query: POSTS_QUERY,
  //     context: { site },
  //     variables: {
  //       featuredInBlocks: true,
  //       offset,
  //       limit: 100,
  //     },
  //   }),
  //   data => data.posts.nodes,
  //   data => data.posts.pageInfo.offsetPagination.hasMore
  // )

  // sites.forEach(site => {
  //   site[1].forEach(p => {
  //     paths.push({
  //       params: {
  //         site: site[0],
  //         slug: p.slug,
  //       },
  //     })
  //   })
  // })

  return {
    paths,
    fallback: true,
  }
}
